function isSelectable(value: string) {
  // the row is only selectable if "ConfirmationCode" is not "REJECTED"
  return value !== 'REJECTED'
}

export function isRowSelectable(event: any) {
  if (event.data.Status) {
    if (event.data.Status === 'ADDED' || event.data.Status === 'REJECTED')
      return false
    return true
  }
  return isSelectable(event.data.ConfirmationCode)
}

export function rowClassName(data: any) {
  if (data.Status) {
    if (data.Status === 'REJECTED') return 'p-disabled'
    return ''
  }
  return isSelectable(data.ConfirmationCode) ? '' : 'p-disabled'
}
